import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { CCM_ONBOARDING_CSV_REPORT } from 'services/dataService/resources';
import { useEffect } from 'react';
import { showResult } from 'infrastructure/hooks/utils';

import { defaultCcmStatuses } from './use-onboarding-status-report';

import type { ICcmOnboardingStatusReportFilters } from 'infrastructure/interfaces';

interface ISendReportResponse {
  response: string;
}

const mutationFn = async (postData: ICcmOnboardingStatusReportFilters) => {
  const { error, data } = await dataService.createOne<ISendReportResponse>(
    CCM_ONBOARDING_CSV_REPORT,
    {
      clinicGuid: postData.clinicGuid.length ? postData.clinicGuid : undefined,
      doctorGuid: postData.doctorGuid,
      patientGuid: postData.patientGuid,
      ccmStatuses: postData.ccmStatuses.length
        ? postData.ccmStatuses
        : defaultCcmStatuses,
      pcmStatus: postData.pcmStatus,
      childClinic: postData.childClinic,
    },
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useSendReport = () => {
  const { mutate, data, isLoading, error } = useMutation<
    ISendReportResponse | undefined,
    string | undefined,
    ICcmOnboardingStatusReportFilters
  >({
    mutationFn,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { sendReport: mutate, sendData: data, sendLoading: isLoading };
};
